if (!customElements.get('section-combine')) {
    customElements.define('section-combine', class SectionCombine extends HTMLElement {
        constructor() {
            super()
            this.init()
            this.combineLine = this.querySelector('.combine-line')
        }

        init() {
            const _this = this
            const swiperContainer = this.querySelector('swiper-component')
            const footerItems = this.querySelectorAll('.combine-item-footer')
            const swiper = swiperContainer.swiper

            swiper.on('slideChange', (e) => {
                $(footerItems).not(footerItems[e.activeIndex]).removeClass('active')
                $(footerItems[e.activeIndex]).addClass('active')
                _this.renderCombineLine(e.activeIndex == 0)
            })
            $(footerItems).on('click', function () {
                $(this).addClass('active')
                $(footerItems).not(this).removeClass('active')
                swiper.slideTo(this.dataset.index ?? 0)
                _this.renderCombineLine(this.dataset.index == 0)
            })
        }

        renderCombineLine(flag) {
            flag ? this.combineLine.classList.remove('active') : this.combineLine.classList.add('active')
        }
    })
}